<template>
  <div class="head">
    <div class="img" v-show="data.state === 'INVALID'">
      <img :src="require('@/assets/mine/已取消.svg')" alt="" />
    </div>
    <div class="body">
      <p class="status">{{ data.state | status_f(returnOrderState) }}</p>
      <div class="list">
        <div class="cell">
          <p class="label">服务类型</p>
          <p class="value">
            {{ data.serverType | status_f(returnOrderServerType) }}
          </p>
        </div>
        <div class="cell" v-show="data.dismissReason">
          <p class="label">拒绝原因</p>
          <p class="value">{{ data.dismissReason }}</p>
        </div>
        <div class="cell">
          <p class="label">订单编号</p>
          <p class="value">{{ data.orderNo }}</p>
        </div>
        <div class="cell">
          <p class="label">退单编号</p>
          <p class="value">{{ data.id }}</p>
        </div>
        <div class="cell">
          <p class="label">下单时间</p>
          <p class="value">
            {{ dayjs(data.createTime).format('YYYY-MM-DD HH:mm:ss') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      returnOrderState: (state) => state.options.returnOrderState,
      returnOrderServerType: (state) => state.options.returnOrderServerType,
    }),
  },
  filters: {
    status_f(val, list) {
      const i = list.find((item) => item.value === val)
      return (i && i.label) || ''
    },
  },
}
</script>

<style lang="less" scoped>
.head {
  display: flex;
  align-items: flex-end;
  background: #c82d26;
  padding: 22px 52px 140px;
  .img {
    img {
      width: 132px;
      height: 154px;
    }
  }
  .body {
    flex: 1;
    min-width: 0;
    padding-left: 20px;
  }
  .status {
    font-size: 40px;
    color: #ffffff;
    line-height: 40px;
  }
  .list {
    padding-top: 24px;
    .cell {
      display: flex;
      font-size: 24px;
      color: #ffffff;
      line-height: 24px;
      & + .cell {
        margin-top: 12px;
      }
      .value {
        padding-left: 24px;
      }
    }
  }
}
</style>